import React, { useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./ExpeditionControls.scss";
import { convertMSToHMS } from "../../../../helpers/Dates";
import TabbedPanel from "../../../TabbedPanel/TabbedPanel";
import EXPEDITION_LIVE_STATE from "./ExpeditionLiveState";
import Toggle from "../../../forms/Toggle/Toggle";
import HMSTimeField from "../../../forms/HMSTimeField/HMSTimeField";
import TextArea from "../../../forms/TextArea/TextArea";

const ExpeditionMessagesControls = (props) => {
    const featureIdForCommands = props.previewControls ? 'previewFrame' : props.featureId;
    const primaryStream = props.featureVars.manageExpeditionControls.masterStream;
    const expeditionDataFetched = props.expeditionDataFetched;
    
    const [buttonClickedWaitingForUpdate, setButtonClickedWaitingForUpdate] = useState(false);
    useEffect(() => {
        setButtonClickedWaitingForUpdate(false);
    }, [props]);

    const [selectedTeamIndex, setSelectedTeamIndex] = useState(0);

    const getTeamDropdownListData = () => {
        const listData = [];
        if (props.customisationData?.setup?.teams?.teams && props.customisationData.setup.teams.teams.length > 0) {
            for (let i = 0; i < props.customisationData.setup.teams.teams.length; i++) {
                listData.push({value: i, label: props.customisationData.setup.teams.teams[i].name});
            }
        }
        return listData;
    }
    const teamsListData = getTeamDropdownListData();

    const [messageToSend, setMessageToSend] = useState(props.featureVars?.expeditionMessagesControls?.messageToSend ?? "");
    const [chatUnlockTime, setChatUnlockTime] = useState(props.featureVars?.expeditionMessagesControls?.chatUnlockTime ?? 120);

    const getStateData = () => {
        let stateData = null;
        if (props.previewControls && props?.passedInPreviewData?.expeditionState) {
            stateData = props.passedInPreviewData.expeditionState;
        }
        if (!props.previewControls && expeditionDataFetched) {
            stateData = EXPEDITION_LIVE_STATE.expeditionMainState;
        }
       /*  if (stateData === null) {
            stateData = props?.featureVars?.expeditionState;
        } */
        if (stateData) {
            // console.log('--- ExpeditionControls, stateData: ', stateData);
            return stateData;
        }
        // Default state data
        return {
            expeditionInited: false,
        };
    }

    const getOverlaysStateData = () => {
        let overlaysStateData = null;
        if (props.previewControls && props?.passedInPreviewData?.activeOverlays) {
            overlaysStateData = props.passedInPreviewData.activeOverlays;
        }
        if (overlaysStateData === null) {
            overlaysStateData = props?.featureVars?.activeOverlays;
        }
        if (overlaysStateData) {
            return overlaysStateData;
        }
        return {
            alerts: [],
            teamStats: [],
        };
    }

    const stateData = getStateData();
    const overlaysStateData = getOverlaysStateData();
    const streamOverlayActive = overlaysStateData?.streamOverlayActive === true;

    const isMessageAlertOverlayActive = (itemIndex) => {
        const messageAlert = overlaysStateData.alerts.find((overlay) => {
            return overlay.type === 'message_alert' && overlay.teamIndex === selectedTeamIndex;
        });
        return messageAlert ? true : false;
    }

    const isChatUnlockedOverlayActive = (teamIndex = null) => {
        const chatUnlockAlert = overlaysStateData.alerts.find((overlay) => {
            return overlay.type === 'chat_unlocked_alert' && ((teamIndex === null && overlay.allTeams) || overlay.teamIndex === teamIndex);
        });
        return chatUnlockAlert ? true : false;
    }

    const updateReceivedCallback = (newExpeditionState, sentData) => {
        // console.log('--- ExpeditionControls, updateReceivedCallback: ', data);
        setButtonClickedWaitingForUpdate(false);
    }
    useEffect(() => {
        EXPEDITION_LIVE_STATE.registerUpdateListener(updateReceivedCallback);
        console.log('--- ExpeditionMessagesControls, useEffect (mounted)', props);
        return () => {
            EXPEDITION_LIVE_STATE.unregisterUpdateListener(updateReceivedCallback);
        }
    }, []);

    return (
        <>
            <div className="generic-feature-status fl-column" style={{marginBottom: '-1rem'}}>
                {!primaryStream &&
                    <div className="bold-text warning-text">
                        These controls are only available on the Primary Stream.
                    </div>
                }
                {primaryStream && (!stateData.expeditionInited || !stateData.expeditionActive) &&
                    <div className="bold-text attention-text">
                        These controls are only available during an active expedition.
                    </div>
                }
                {primaryStream && stateData.expeditionInited && stateData.expeditionActive &&
                    <>
                        <FormDropDown
                            label={"Send Message To"}
                            items={teamsListData}
                            value={selectedTeamIndex}
                            selectFunc={
                                (e, id, item) => {
                                    setSelectedTeamIndex(item.value);
                                }
                            }
                            currentIndex={selectedTeamIndex}
                            showErrors={false}
                            enabled={teamsListData.length > 0}
                        />
                        <TextArea
                            label={"Message To Send"}
                            // labelNote={varVal.description || ''}
                            id={'messageToSend'}
                            setFunc={(newVal) => { setMessageToSend(newVal); }}
                            confirmChangeFunc={(newVal) => {props.featureVars.expeditionMessagesControls.messageToSend = newVal}}
                            value={messageToSend}
                            showError={false}
                            placeholder={String("Enter the message to send to the selected team...")}
                            rows={4}
                        />
                        <div className="button-grid">
                            <button className={`standard-button ${(buttonClickedWaitingForUpdate /* || isMessageAlertOverlayActive() */) ? 'button-inactive' : ''}`} onClick={(buttonClickedWaitingForUpdate /* || isMessageAlertOverlayActive() */) ? null : () => {
                                if (messageToSend.trim().length === 0) {
                                    return;
                                }
                                setButtonClickedWaitingForUpdate(true);
                                if (props.previewControls) {
                                    props.sendFeatureCommandFunc(null, "PREVIEW_SEND_MESSAGE", featureIdForCommands, {teamIndex: selectedTeamIndex, message: messageToSend});
                                } else {
                                    // props.sendFeatureCommandFunc(primaryStream, "SEND_MESSAGE", featureIdForCommands, {teamIndex: selectedTeamIndex, message: messageToSend});
                                    EXPEDITION_LIVE_STATE.sendMessageToTeam(selectedTeamIndex, messageToSend);
                                }
                            }}>
                                Send Message Now
                            </button>
                        </div>
                        <hr />
                        <div className="fl-column no-gap">
                            <div className="label">Unlock Chat For</div>
                            <div className="fl-row">
                                <div className="shrink" style={{marginLeft: '-1rem', marginRight: '-1rem'}}>
                                    <HMSTimeField
                                        label={`Unlock Chat For ${teamsListData[selectedTeamIndex].label}`}
                                        id={'chatUnlockTime'}
                                        setFunc={(newVal) => { setChatUnlockTime(newVal); props.featureVars.expeditionMessagesControls.chatUnlockTime = newVal; }}
                                        value={chatUnlockTime}
                                        showError={false}
                                        showHours={false}
                                        showLabel={false}
                                    />
                                </div>
                                <div className="button-grid" style={{width: '100%', marginBottom: 0}}>
                                    <button className={`standard-button ${(buttonClickedWaitingForUpdate || isChatUnlockedOverlayActive(selectedTeamIndex)) ? 'button-inactive' : 'live-but-green'}`} style={{width: '100%'}} onClick={(buttonClickedWaitingForUpdate || isChatUnlockedOverlayActive(selectedTeamIndex)) ? null : () => {
                                        setButtonClickedWaitingForUpdate(true);
                                        if (props.previewControls) {
                                            props.sendFeatureCommandFunc(null, "PREVIEW_UNLOCK_CHAT", featureIdForCommands, {duration: chatUnlockTime});
                                        } else {
                                            // props.sendFeatureCommandFunc(primaryStream, "UNLOCK_CHAT", featureIdForCommands, {duration: chatUnlockTime});
                                            EXPEDITION_LIVE_STATE.unlockChatForTeam(chatUnlockTime, selectedTeamIndex);
                                        }
                                    }}>
                                        Unlock {teamsListData[selectedTeamIndex].label} Chat Now
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="fl-column no-gap">
                            <div className="fl-row">
                                <div className="button-grid" style={{width: '100%', marginBottom: 0}}>
                                    <button className={`standard-button ${(buttonClickedWaitingForUpdate || isChatUnlockedOverlayActive()) ? 'button-inactive' : 'live-but-orange'}`} style={{width: '100%'}} onClick={(buttonClickedWaitingForUpdate || isChatUnlockedOverlayActive()) ? null : () => {
                                        setButtonClickedWaitingForUpdate(true);
                                        if (props.previewControls) {
                                            props.sendFeatureCommandFunc(null, "PREVIEW_UNLOCK_CHAT", featureIdForCommands, {duration: chatUnlockTime});
                                        } else {
                                            EXPEDITION_LIVE_STATE.unlockChatForAllTeams(chatUnlockTime);
                                        }
                                    }}>
                                        Unlock Chat For All Teams Now
                                    </button>
                                </div>
                            </div>
                        </div>

                    </>
                }
            </div>
        </>
    );
}

export default ExpeditionMessagesControls;